import { render, staticRenderFns } from "./AccessadTable.vue?vue&type=template&id=371fce17&scoped=true&"
import script from "./AccessadTable.vue?vue&type=script&lang=js&"
export * from "./AccessadTable.vue?vue&type=script&lang=js&"
import style0 from "./AccessadTable.vue?vue&type=style&index=0&id=371fce17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371fce17",
  null
  
)

export default component.exports